import { createSvgIcon } from '@automata/mui-theme';
export const PrimeIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M50.1924 25.8252L43.1213 18.7542L41 20.8755L48.0711 27.9465L50.1924 25.8252Z" />
    <path d="M48.083 27.9465L55.1541 20.8754L53.0328 18.7541L45.9617 25.8252L48.083 27.9465Z" />
    <path d="M46.577 25H49.577V13H46.577V25Z" />
    <path d="M32 16H35V50H32V16Z" />
    <path d="M61 16H64V50H61V16Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.5283 80C49.9464 80 52.0566 77.9557 52.0566 75.2462C52.0566 74.4999 51.7847 73.4471 51.1658 72.1319C50.5644 70.8537 49.7333 69.5324 48.8548 68.3078C48.4042 67.6797 47.9518 67.0918 47.5283 66.565C47.1048 67.0918 46.6524 67.6797 46.2018 68.3078C45.3233 69.5324 44.4922 70.8537 43.8908 72.1319C43.2719 73.4471 43 74.4999 43 75.2462C43 77.9557 45.1103 80 47.5283 80ZM45.5367 64.2594C43.3063 66.9681 40 71.5987 40 75.2462C40 79.5285 43.3705 83 47.5283 83C51.6861 83 55.0566 79.5285 55.0566 75.2462C55.0566 71.5987 51.7503 66.9681 49.5199 64.2594C48.3847 62.8808 47.5283 62 47.5283 62C47.5283 62 46.6719 62.8808 45.5367 64.2594Z"
    />
    <path d="M46 41C46 42.1046 45.1046 43 44 43C42.8954 43 42 42.1046 42 41C42 39.8954 42.8954 39 44 39C45.1046 39 46 39.8954 46 41Z" />
    <path d="M52 45C52 46.1046 51.1046 47 50 47C48.8954 47 48 46.1046 48 45C48 43.8954 48.8954 43 50 43C51.1046 43 52 43.8954 52 45Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53 53H43V57H53V53ZM40 50V60H56V50H40Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.0778 33.6004C54.0858 29.7519 58.4807 29.7537 61 30.1892V50H56V53H62C63.1046 53 64 52.1046 64 51V29.2281C64 28.4188 63.5131 27.6931 62.729 27.4929C60.0662 26.8131 53.6781 25.9842 48 31.4364C44.0376 35.2412 39.2319 33.3769 35.9277 31.1767C34.4105 30.1664 32 31.2005 32 33.0233V51C32 52.1046 32.8954 53 34 53H40V50H35V34.144C36.7381 35.2102 38.9318 36.2316 41.3425 36.5349C44.2536 36.9013 47.3764 36.1943 50.0778 33.6004Z"
    />
  </svg>,
  'PrimeIcon'
);
